import React from 'react';
import {
  Container, Col, Row,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  Heading2,
  LinkStyled,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="TilslutningAfFadoelsanlaeg">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Tilslutning af fadølsanlæg, fadøl og kulsyre</Heading1>
          <Paragraph>
            Tilslutning af fadølsanlæg samt fadøl og kulsyre er vigtigt for at kunne servere en god øl og give den bedste oplevelse. Tilslutningen af fadøl og kulsyre er heldigvis let. Følg blot vores guide nedenfor.
            Hos Skafte kan du altid <LinkStyled to="/fadoelsanlaeg">leje et fadølsanlæg</LinkStyled> til dit næste arrangement, event eller fest, uanset størrelse og antallet af gæster.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading2>Tilslutning af fadølsanlæg, fadøl og kulsyre</Heading2>
        </Col>
        <Col xs={12} doubleColumn paddingTop="0px">
          <Paragraph>
            Tilslutning af fadølsanlæg til fadøl og kulsyre bør gøres inden baren slås ud. Start med at sætte kulsyren til, ved at sætte gevindet på. Drej omløberen med fingrene, så langt som du kan skrue den. Stram derefter til med den påhængte nøgle. Du må gerne bruge godt med kræfter, så du er sikker på, at den er tæt.
          </Paragraph>
          <Paragraph>
            Tag herefter fadølskoblingen og sørg for, at håndtaget er oppe. Åben kulsyren alt hvad den kan, hvilket er ca. to omgange mod uret og så en halv omgang tilbage. Vip nu håndtaget på fadølskoblingen ned. Skulle der være vand eller rensevæske i slangerne, så bliver det blæst ud, så det ikke kommer ned i ølfustagen.
          </Paragraph>
          <Paragraph>
            Fjern låget på fustagen, ved at knække det af. På en S-kobling er der to hakker på fustagen og to slidser i siden af koblingen. De to slidser skal fange de to hakker. Drej en kvart omgang med uret og tryk håndtaget ned for komplet tilslutning af fadølsanlæg og fustage.
          </Paragraph>
          <Paragraph>
            Når det skal af igen, så trykker man lidt ned på håndtaget, hiver ud og løfter op. Herefter drejer man koblingen en kvart omgang mod uret, og tager den af. Er man en smule usikker når man skal skifte fustage, så kan det være en god idé at lukke for kulsyreflasken. Det er ikke nødvendigt, men skulle der gå noget galt, så risikerer man ikke, at der sprøjter øl og kulsyre ud.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer
            url="fbAsc4Z5AfI?t=80"
            thumbnail="tilslutning-af-fadoel"
            chapters={[
            {
              time: '00:00',
              description: '00:00 - Opstilling af udstyr og tilslutning af strøm',
            },
            {
              time: '01:19',
              description: '01:19 - Tilslutning af fadøl og kulsyre til fadølsanlæg',
            },
            {
              time: '03:11',
              description: '03:11 - Sådan virker vandkølede fadølsanlæg',
            },
            {
              time: '06:06',
              description: '06:06 - Opsætning af fadølsbar og tappetårn',
            },
            {
              time: '07:13',
              description: '07:13 - Forberedelse før tapning af fadøl',
            },
            {
              time: '08:36',
              description: '08:36 - Sådan tapper du en perfekt fadøl',
            },
          ]}
          />
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
